<div class="d-flex justify-content-center">
  <iframe [src]="trustedURL" width="80%" height="1000px"></iframe>
</div>
